import React, { useState } from 'react';
import axios from 'axios';
import EmployeeForm from './components/EmployeeForm';
import { Button, Container, Typography, Box } from '@mui/material';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import SendIcon from '@mui/icons-material/Send';
import './App.css';


const App = () => {
  const [employees, setEmployees] = useState([{
    empCode: '',
    empName: '',
    date: '',
    email: '',
    greetingType: 'birthday',
    photo: null
  }]);

  const addEmployee = () => {
    setEmployees([...employees, {
      empCode: '',
      empName: '',
      date: '',
      email: '',
      greetingType: 'birthday',
      photo: null
    }]);
  };

  const updateEmployee = (index, field, value) => {
    const updatedEmployees = [...employees];
    updatedEmployees[index][field] = value;
    setEmployees(updatedEmployees);
  };

  const removeEmployee = (index) => {
    setEmployees(employees.filter((_, i) => i !== index));
  };

  const sendGreetings = async () => {
    try {
      const formData = new FormData();
      const employeeData = employees.map(employee => ({
        empCode: employee.empCode,
        empName: employee.empName,
        date: employee.date,
        email: employee.email,
        greetingType: employee.greetingType
      }));
      formData.append('employees', JSON.stringify(employeeData));
      employees.forEach((employee) => {
        if (employee.photo) {
          formData.append('employees', employee.photo);
        }
      });

      const response = await axios.post('https://wish.lilyb.in/send-greetings', formData, {
        headers: { 'Content-Type': 'multipart/form-data' }
      });
      alert(response.data.message);
    } catch (error) {
      console.error('Error:', error);
      if (error.response) {
        console.error('Response data:', error.response.data);
        console.error('Response status:', error.response.status);
      }
      alert('Error sending greetings: ' + error.message);
    }
  };

  return (
    <Container maxWidth="lg" className="py-6 bg-gray-100 min-h-screen">
      <Typography variant="h4" align="center" color="primary" gutterBottom>
        Employee Greetings Sender
      </Typography>
      {employees.map((employee, index) => (
        <EmployeeForm
          key={index}
          employee={employee}
          index={index}
          updateEmployee={updateEmployee}
          removeEmployee={removeEmployee}
          showRemove={employees.length > 1}
        />
      ))}
      <Box display="flex" justifyContent="space-between" mt={4}>
        <Button
          variant="contained"
          color="primary"
          startIcon={<AddCircleOutlineIcon />}
          onClick={addEmployee}
        >
          Add Employee
        </Button>
        <Button
          variant="contained"
          color="success"
          startIcon={<SendIcon />}
          onClick={sendGreetings}
        >
          Send Greetings
        </Button>
      </Box>
    </Container>
  );
};

export default App; 